export enum SegmentationCategoryTypeEnum {
    None = 0,
    AIPredicted = 1,
}

export enum ComparisonUITypeEnum {
    Text = 0,
    DropDown = 1,
    AutoComplete = 2,
    Date = 3,
    DateWithin = 4,
    Number = 5,
    NumberWithin = 6,
    RadioButtonBox = 7,
    Currency = 8,
    CurrencyWithin = 9,
    CascadingDropdown = 10,
    CascadingDropdownPath = 11,
    MonthDay = 12,
    MonthDayWithin = 13,
    MultiSelect = 14,
    TreeViewWithCascadingDropdown = 15,
    CascadeDataMultiCall = 16,
    TreeView = 17,
    DateTime = 18,
    DateTimeWithin = 19,
    Decimal = 20,
    FourStepsCascadeData = 21,
    TimeSpan = 22,
    Money = 23,
    FiveStepsCascadeData = 24,
    Time = 25,
    Percentage = 26,
    PercentageWithin = 27,
}
